<template>
  <base-row
    v-bind="$props"
    :selectable="false"
  >
    <td>
      <span class="text-blue-600 hover:text-blue-600"> #{{ item.id }} </span>
    </td>
    <td>
      {{ item.name }}
    </td>
    <td>
      {{ item.points }}
    </td>
    <td>
      {{ item.discount_amount ? _dollars(item.discount_amount) : '-' }}
    </td>
    <td>
      {{ percent(item.discount_rate) }}
    </td>
    <td>
      {{ _dollars(item.min_price) }}
    </td>
    <td>
      {{ _dollars(item.max_price) }}
    </td>
  </base-row>
</template>

<script>
import { Link } from '@inertiajs/vue3'
import TableRow from '@/Components/Table/TableRow'
import RowProps from '@/Components/Table/Mixins/RowProps'
import BasicBadge from '@/Components/Badges/BasicBadge.vue'
import _datetime from '@/Filters/DateTime'
import _dollars from '@/Filters/Dollars'

export default {
  components: {
    'base-row': TableRow,
    Link,
    BasicBadge
  },

  mixins: [RowProps],

  props: {},

  methods: {
    _datetime,
    _dollars,

    percent(value) {
      if (isNaN(value)) {
        return '-'
      }

      return Math.round(parseFloat(value) * 100) + '%'
    }
  }
}
</script>
